module.exports = __webpack_public_path__ + "media/images/new_landing/hp/tile-7-f0f2f537fff34449f849eb6ac3b2c35c.jpg";